import { render, staticRenderFns } from "./Emerge.vue?vue&type=template&id=d5106fbc"
import script from "./Emerge.vue?vue&type=script&lang=js"
export * from "./Emerge.vue?vue&type=script&lang=js"
import style0 from "./Emerge.vue?vue&type=style&index=0&id=d5106fbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports